import React from "react"
import Form from "@rjsf/material-ui"
import { FormProps } from "@rjsf/core"

export default function CustomForm({ ...formProps }: FormProps<any>) {
  return <Form showErrorList={true} {...formProps} />
}
